// Kroatische Oberflaechen-Texte Teil 1, erstellt 15.09.2026, gegenzulesen. Schluessel = deutscher Text.

export const UI_HR_TEIL1 = {
  "! Mangel (>2Ω)": "! Nedostatak (>2Ω)",
  "(Du kannst auch \"Abbrechen\" und die fehlenden Punkte zuerst ausfuellen.)": "(Možeš i \"Odustani\" i prvo ispuniti točke koje nedostaju.)",
  "(gesperrt: \"Kein Schutz\" aktiv)": "(zaključano: aktivno \"Nema zaštite\")",
  "(gesperrt: andere Schutz-Option aktiv)": "(zaključano: aktivna druga opcija zaštite)",
  "(ohne Namen)": "(bez imena)",
  "(ohne Titel)": "(bez naslova)",
  "+ Anschluss": "+ Priključak",
  "+ Feld hinzufügen": "+ Dodaj polje",
  "+ Neue Schiene": "+ Nova sabirnica",
  "+ Trafo fehlt? Hier nachtragen": "+ Nedostaje transformator? Dodaj ovdje",
  "+ Transformator hinzufuegen": "+ Dodaj transformator",
  "+ Wartung selbst anlegen": "+ Sam kreiraj održavanje",
  "- wurde in das Feld oben uebertragen.": "- preneseno je u polje gore.",
  "-- bitte wählen --": "-- odaberi --",
  ". Danach lassen sich hier die Schienen und Anschlüsse der Erderanlage anlegen.": ". Nakon toga ovdje možeš dodati sabirnice i priključke uzemljivača.",
  "... und {n} weitere": "... i još {n}",
  "1 Eingabe wartet auf Netz.": "1 unos čeka mrežu.",
  "4-adrig": "4-žilni",
  "5-adrig": "5-žilni",
  "ABGESCHLOSSEN": "ZAVRŠENO",
  "ABSCHLUSS": "ZAVRŠETAK",
  "Abbrechen": "Odustani",
  "Abgeschlossen, wartet auf das Büro": "Završeno, čeka ured",
  "Abmelden": "Odjava",
  "Abschluss-Bemerkung (optional)": "Završna napomena (neobavezno)",
  "Achtung: {n} Pruefpunkte sind noch nicht beantwortet:": "Pažnja: {n} točaka provjere još nije odgovoreno:",
  "Adernanzahl L1": "Broj žila L1",
  "Adernanzahl L2": "Broj žila L2",
  "Adernanzahl L3": "Broj žila L3",
  "Adernanzahl N": "Broj žila N",
  "Adernanzahl PE+N": "Broj žila PE+N",
  "Aeltestes Bauteil von {jahr} ist {alter} Jahre alt (<=25).": "Najstariji dio iz {jahr} star je {alter} godina (<=25).",
  "Aeltestes Bauteil von {jahr} ist {alter} Jahre alt (>25).": "Najstariji dio iz {jahr} star je {alter} godina (>25).",
  "Aggregat erforderlich": "Potreban agregat",
  "Aktuelle Position": "Trenutna lokacija",
  "Alle Eingaben werden automatisch gespeichert. Bei \"n.i.O.\" wird automatisch ein Mangel angelegt.": "Svi unosi se automatski spremaju. Kod \"neispravno\" automatski se kreira nedostatak.",
  "Alle Trafos sind Gießharztrafos – kein Öl, nichts aufzufangen.": "Svi transformatori su s lijevanom smolom (GH) – nema ulja, nema se što skupljati.",
  "Alle als ZIP": "Sve kao ZIP",
  "Alle, die dabei waren — z. B. „Jelenic, Urban, Gallo\"": "Svi koji su bili prisutni — npr. „Jelenic, Urban, Gallo\"",
  "Allgemeine Notizen zum Trafo": "Opće bilješke o transformatoru",
  "Angaben zur Wartung": "Podaci o održavanju",
  "Angefangen, noch nicht fertig": "Započeto, još nije gotovo",
  "Angeschlossen": "Priključeno",
  "Anlagensicherheit": "Sigurnost postrojenja",
  "Anlagensicherheit nicht gewährleistet": "Sigurnost postrojenja nije osigurana",
  "Anschluesse": "Priključci",
  "Anschluss \"{name}\" wirklich löschen?": "Stvarno obrisati priključak \"{name}\"?",
  "Anschluss am Transformator ausgeführt mit": "Priključak na transformatoru izveden s",
  "Anschluss-Status": "Status priključka",
  "Anschlussfahnen / -bolzen": "Priključne zastavice / svornjaci",
  "Anschlussklemme": "Priključna stezaljka",
  "Anschlussloch Kabelschuh - NSHV": "Rupa kabelske stopice - NNGR",
  "Anschlussloch Kabelschuh - Trafo": "Rupa kabelske stopice - transformator",
  "Anschlussschienen": "Priključne sabirnice",
  "Anschlussschienen mit Abdeckung": "Priključne sabirnice s pokrovom",
  "Ansprechpartner": "Kontakt osoba",
  "Anzahl Felder": "Broj polja",
  "Anzahl Schaltstufen": "Broj sklopnih stupnjeva",
  "App neu laden": "Ponovno učitaj aplikaciju",
  "Auf dem Gerät gespeichert, geht automatisch raus.": "Spremljeno na uređaju, šalje se automatski.",
  "Auf dem Gerät gespeichert.": "Spremljeno na uređaju.",
  "Aufgrund der durchgeführten Wartung und Berücksichtigung aller Faktoren wie Alter, Zustand, Standort etc. empfehlen wir:": "Na temelju provedenog održavanja i uzimajući u obzir sve čimbenike kao što su starost, stanje, lokacija itd. preporučujemo:",
  "Auftraggeber: {name}": "Naručitelj: {name}",
  "Ausloesespule an MS-Anlage": "Okidni svitak na SN postrojenju",
  "Auswählen oder eigenen eintippen": "Odaberi ili upiši vlastiti",
  "Automatisch aus den Stufen berechnet: {wert} % — kann von Hand überschrieben werden": "Automatski izračunato iz stupnjeva: {wert} % — može se ručno promijeniti",
  "Außenleiter L1 • L2 • L3": "Fazni vodiči L1 • L2 • L3",
  "Bauform": "Izvedba",
  "Bauform (Mehrfachauswahl möglich)": "Izvedba (moguć višestruki odabir)",
  "Baujahr": "Godina proizvodnje",
  "Baujahr liegt in der Zukunft. Vertippt?": "Godina proizvodnje je u budućnosti. Tipfeler?",
  "Baujahr vor 1900 - bitte prüfen.": "Godina proizvodnje prije 1900. - provjeri.",
  "Baureihen des Herstellers zur Auswahl": "Serije proizvođača za odabir",
  "Bei > 2 Ω oder „OL“ wird automatisch ein Mangel angelegt.": "Kod > 2 Ω ili „OL“ automatski se kreira nedostatak.",
  "Bei Bedienung von außen (kein begehbarer Raum) evtl. nicht nötig.": "Kod rukovanja izvana (bez prohodnog prostora) možda nije potrebno.",
  "Bei nicht begehbarer Station (Bedienung von außen) evtl. nicht nötig.": "Kod neprohodne stanice (rukovanje izvana) možda nije potrebno.",
  "Bemerkung": "Napomena",
  "Bemerkung (optional)": "Napomena (neobavezno)",
  "Berechnetes Volumen": "Izračunati volumen",
  "Berührbare aktive Teile: Der Warnbalken verhindert das Hineingreifen.": "Dodirljivi dijelovi pod naponom: upozoravajuća prečka sprječava posezanje unutra.",
  "Betriebssicherheit": "Pogonska sigurnost",
  "Betriebssicherheit nicht gewährleistet": "Pogonska sigurnost nije osigurana",
  "Betriebsspannung [kV]": "Pogonski napon [kV]",
  "Betriebsspannung, z. B. 20": "Pogonski napon, npr. 20",
  "Bewertung & Unterschrift": "Ocjena i potpis",
  "Bewertung Auffangwanne": "Ocjena uljne kade",
  "Bewertung nicht eindeutig": "Ocjena nije jednoznačna",
  "Bewertung noch nicht moeglich": "Ocjena još nije moguća",
  "Bezeichnung": "Oznaka",
  "Bezeichnung, z. B. \"Trafo 2\"": "Oznaka, npr. \"Trafo 2\"",
  "Bild hinzufügen": "Dodaj sliku",
  "Bild kann nicht geladen werden": "Slika se ne može učitati",
  "Bilder": "Slike",
  "Bitte alle drei Wannenmasse (Laenge, Breite, Hoehe) eintragen.": "Upiši sve tri mjere kade (duljina, širina, visina).",
  "Bitte das Büro informieren. Deine Eingaben bleiben erhalten.": "Obavijesti ured. Tvoji unosi ostaju sačuvani.",
  "Bitte die Station zuerst": "Molim prvo stanicu",
  "Bitte noch belegen:": "Još popuni:",
  "Bitte oben am Trafo das Gesamt-Oelgewicht (kg) eintragen, sonst kann nicht berechnet werden, ob die Wanne ausreicht.": "Gore kod transformatora upiši ukupnu težinu ulja (kg), inače se ne može izračunati je li kada dovoljna.",
  "Bitte wähle ein sicheres Passwort (mind. 8 Zeichen).": "Odaberi sigurnu lozinku (najmanje 8 znakova).",
  "Bitte zuerst deinen Namen eintragen.": "Prvo upiši svoje ime.",
  "Bitte zuerst unterschreiben.": "Prvo se potpiši.",
  "Breite B [m]": "Širina B [m]",
  "Buchholz": "Buchholz",
  "Büro": "Ured",
  "Clean Air": "Clean Air",
  "Da ist etwas hängen geblieben": "Nešto je zapelo",
  "Danach geplant": "Zatim planirano",
  "Daraus folgt: {liste} nicht gewährleistet.": "Iz toga slijedi: {liste} nije osigurano.",
  "Das Protokoll konnte nicht geladen werden": "Zapisnik se nije mogao učitati",
  "Das dauert ungewöhnlich lange – vermutlich schwaches Netz. Eingaben gehen nicht verloren.": "Ovo traje neobično dugo – vjerojatno slaba mreža. Unosi se neće izgubiti.",
  "Das sieht nach einem Datum aus, nicht nach einem Jahr.": "Ovo izgleda kao datum, a ne godina.",
  "Datei kann nicht gelesen werden": "Datoteka se ne može pročitati",
  "Datenbank lehnt ab": "Baza podataka odbija",
  "Datum": "Datum",
  "Datum bitte als TT.MM.JJJJ": "Datum u obliku DD.MM.GGGG",
  "Datum bitte als TT.MM.JJJJ, MM.JJJJ oder JJJJ": "Datum u obliku DD.MM.GGGG, MM.GGGG ili GGGG",
  "Datum löschen": "Obriši datum",
  "Dein Abschluss ist auf dem Gerät gespeichert und wird automatisch übertragen, sobald du wieder Empfang hast.": "Tvoj završetak je spremljen na uređaju i automatski će se prenijeti čim ponovno imaš signal.",
  "Dein Abschluss ist auf dem Gerät gespeichert. Er wird automatisch übertragen, sobald alle Antworten draußen sind.": "Tvoj završetak je spremljen na uređaju. Automatski će se prenijeti čim svi odgovori budu poslani.",
  "Deine Eingaben sind auf dem Gerät gespeichert und gehen nicht verloren.": "Tvoji unosi su spremljeni na uređaju i neće se izgubiti.",
  "Der Abschluss geht automatisch raus, sobald sie übertragen sind. Trotzdem jetzt abschließen?": "Završetak se šalje automatski čim oni budu preneseni. Ipak završiti sada?",
  "Der Abschluss wurde von der Datenbank ABGELEHNT:": "Baza podataka je ODBILA završetak:",
  "Der Fehler wurde automatisch an das Büro gemeldet.": "Greška je automatski prijavljena uredu.",
  "Der Messwert wurde von der Datenbank abgelehnt: {fehler}. Bitte im Büro Bescheid geben.": "Baza podataka je odbila izmjerenu vrijednost: {fehler}. Javi uredu.",
  "Der Trafo konnte nicht angelegt werden.": "Transformator se nije mogao kreirati.",
  "Der Trafo steht IN der Wanne und verdraengt einen Teil des Auffangvolumens. Die effektive Auffangmenge ist kleiner als die {volumen} L Bruttovolumen und kann ohne Trafo-Standflaeche nicht exakt berechnet werden.": "Transformator stoji U kadi i istiskuje dio prihvatnog volumena. Stvarna prihvatna količina manja je od {volumen} L bruto volumena i bez površine postolja transformatora ne može se točno izračunati.",
  "Der Trafo wird in den Stammdaten der Station angelegt und bekommt sofort ein eigenes Kapitel in diesem Protokoll. Typenschilddaten kannst du anschliessend dort eintragen.": "Transformator se kreira u matičnim podacima stanice i odmah dobiva vlastito poglavlje u ovom zapisniku. Podatke s natpisne pločice možeš zatim tamo upisati.",
  "Die Erderanlage konnte nicht geladen werden: {fehler}. Bitte Verbindung prüfen.": "Uzemljivač se nije mogao učitati: {fehler}. Provjeri vezu.",
  "Die Freigabe konnte gerade nicht übertragen werden.": "Odobrenje se trenutno nije moglo prenijeti.",
  "Die Isolierart der MS-Anlage fehlt in den Stammdaten. Bitte eintragen – dann schlägt die App passende Punkte vor.": "U matičnim podacima nedostaje vrsta izolacije SN postrojenja. Upiši je – tada aplikacija predlaže odgovarajuće točke.",
  "Die Messwerte konnten nicht geladen werden: {fehler}.": "Izmjerene vrijednosti nisu se mogle učitati: {fehler}.",
  "Die Wartungen konnten nicht geladen werden.": "Održavanja se nisu mogla učitati.",
  "Die abgelehnten Eingaben noch einmal senden?": "Ponovno poslati odbijene unose?",
  "Die Ölauffangwanne hat im Protokoll ein eigenes Kapitel.": "Uljna kada ima vlastito poglavlje u zapisniku.",
  "Die Übertragung läuft automatisch, sobald du wieder Empfang hast.": "Prijenos se pokreće automatski čim ponovno imaš signal.",
  "Diese vier Zeilen stehen oben im Protokoll für den Kunden.": "Ova četiri retka stoje na vrhu zapisnika za kupca.",
  "Download": "Preuzmi",
  "Du kannst die App schließen — es geht nichts verloren.": "Možeš zatvoriti aplikaciju — ništa se neće izgubiti.",
  "Du kannst weiterfahren.": "Možeš nastaviti dalje.",
  "Du änderst Stammdaten in der Wartung. Diese Werte werden direkt in den Stammdaten der Station gespeichert und überschreiben den vorherigen Stand.": "Mijenjaš matične podatke u održavanju. Ove vrijednosti spremaju se izravno u matične podatke stanice i prepisuju prethodno stanje.",
  "Dyn5 und Dyn11 sind die häufigsten": "Dyn5 i Dyn11 su najčešći",
  "E-Mail": "E-pošta",
  "ENTWURF": "NACRT",
  "ETB lädt...": "ETB se učitava...",
  "Eine neue Fassung der App steht bereit.": "Dostupna je nova verzija aplikacije.",
  "Eingabe...": "Unos...",
  "Einzelader": "Jednožilni",
  "Elektrische Daten": "Električni podaci",
  "Empfehlung:": "Preporuka:",
  "Empfohlener Wartungszyklus": "Preporučeni ciklus održavanja",
  "Erderanlage / Hauptpotentialausgleich.": "Uzemljivač / glavno izjednačenje potencijala.",
  "Erklärung schließen": "Zatvori objašnjenje",
  "Erneut senden": "Pošalji ponovno",
  "Erstelle PDF...": "Izrađujem PDF...",
  "Erstelle ZIP...": "Izrađujem ZIP...",
  "Erzeugt OS-Spannungs-Felder": "Kreira polja VN strane",
  "Erzeugt ein PDF zum Speichern, Drucken oder Versenden. Braucht Netz — die Daten kommen frisch aus der Datenbank.": "Izrađuje PDF za spremanje, ispis ili slanje. Treba mrežu — podaci dolaze svježe iz baze podataka.",
  "FREIGEGEBEN": "ODOBRENO",
  "Fehler beim Löschen: {fehler}": "Greška pri brisanju: {fehler}",
  "Fehler beim Speichern": "Greška pri spremanju",
  "Fehler beim Speichern: {fehler}": "Greška pri spremanju: {fehler}",
  "Fehler: {fehler}": "Greška: {fehler}",
  "Feld konnte nicht angelegt werden: {fehler}": "Polje se nije moglo kreirati: {fehler}",
  "Feld konnte nicht entfernt werden: {fehler}": "Polje se nije moglo ukloniti: {fehler}",
  "Feld {nr}": "Polje {nr}",
  "Feld {nr} wirklich entfernen?": "Stvarno ukloniti polje {nr}?",
  "Feld {nr} wurde von der Datenbank abgelehnt: {fehler}. Bitte im Büro Bescheid geben.": "Baza podataka je odbila polje {nr}: {fehler}. Javi uredu.",
  "Feld-Nr.": "Br. polja",
  "Fortfahren?": "Nastaviti?",
  "Foto": "Fotografija",
  "Fotos im Protokoll": "Fotografije u zapisniku",
  "Fotos konnten nicht geladen werden": "Fotografije se nisu mogle učitati",
  "Funktioniert nicht": "Ne radi",
  "Gasbehälter geschlossen – nur Kabelanschlussraum/Stecker messbar.": "Plinski spremnik zatvoren – mjerljiv samo prostor kabelskih priključaka/utikači.",
  "Gehört zur Erdungs- und Kurzschließvorrichtung, die hier nötig ist.": "Pripada napravi za uzemljenje i kratko spajanje (EuK) koja je ovdje potrebna.",
  "Gekapselte Anlage ohne Messfeld: keine offenen Trennstrecken.": "Oklopljeno postrojenje bez mjernog polja: nema otvorenih rastavnih razmaka.",
  "Gesamt-Ölgewicht [kg]": "Ukupna težina ulja [kg]",
  "Gesamtgewicht [kg]": "Ukupna težina [kg]",
  "Gesamtzustand der elektrischen Anlage": "Ukupno stanje električnog postrojenja",
  "Gewicht": "Težina",
  "Giessharz (trocken)": "Lijevana smola (GH, suhi)",
  "Gießharztrafo: Die Wicklungsoberfläche ist im Betrieb nicht berührungssicher.": "Transformator s lijevanom smolom (GH): površina namota u pogonu nije zaštićena od dodira.",
  "Gießharztrafo: Kaltleiter und Auslösegerät prüfen.": "Transformator s lijevanom smolom (GH): provjeri PTC termistore i uređaj za okidanje.",
  "Grundlage:": "Osnova:",
  "Guten Abend": "Dobra večer",
  "Guten Morgen": "Dobro jutro",
  "Guten Tag": "Dobar dan",
  "Hermetic (Oel, geschlossen)": "Hermetički (ulje, zatvoreni)",
  "Hermetic (Öl, geschlossen)": "Hermetički (ulje, zatvoreni)",
  "Hermetik-Trafo: Hermetikschutz / Thermometer prüfen.": "Hermetički transformator: provjeri hermetičku zaštitu / termometar.",
  "Hersteller": "Proizvođač",
  "Hersteller (Gebäude)": "Proizvođač (građevina)",
  "Herstellungsjahr": "Godina proizvodnje",
  "Heute": "Danas",
  "Hier mit Finger oder Stift unterschreiben": "Ovdje se potpiši prstom ili olovkom",
  "Hinweis": "Napomena",
  "Hinweis zur Anlage": "Napomena o postrojenju",
  "Hinweis:": "Napomena:",
  "Hochladen fehlgeschlagen": "Učitavanje nije uspjelo",
  "Häkchen setzen, wenn ein Punkt NICHT gewährleistet ist:": "Označi kvačicom ako točka NIJE osigurana:",
  "Höhe H [cm]": "Visina H [cm]",
  "Im PDF mitdrucken": "Ispiši u PDF-u",
  "In Ordnung": "Ispravno",
  "Isolierart": "Vrsta izolacije",
  "Isolierart übernehmen": "Preuzmi vrstu izolacije",
  "Isolierung liegt im Gasbehälter – nur sichtbare Teile (Kabelstecker, Durchführungen) beurteilen.": "Izolacija je u plinskom spremniku – ocijeni samo vidljive dijelove (kabelske utikače, provodnike).",
  "Ja": "Da",
  "Jetzt laden": "Učitaj sada",
  "Jetzt senden": "Pošalji sada",
  "Jetzt versuchen": "Pokušaj sada",
  "Kabelschuh": "Kabelska stopica",
  "Kabeltyp": "Tip kabela",
  "Kalender": "Kalendar",
  "Kaltleiter": "PTC termistor",
  "Kein Auftraggeber verknuepft.": "Nije povezan naručitelj.",
  "Kein Gießharztrafo – das Warnschild gilt nur für GH-Trafos.": "Nije transformator s lijevanom smolom – znak upozorenja vrijedi samo za GH transformatore.",
  "Kein Netz: Die MS-Felder sind auf dem Gerät gespeichert und werden automatisch gesendet.": "Nema mreže: SN polja su spremljena na uređaju i automatski će se poslati.",
  "Kein Netz: Die Messwerte sind auf dem Gerät gespeichert und werden automatisch gesendet.": "Nema mreže: izmjerene vrijednosti su spremljene na uređaju i automatski će se poslati.",
  "Kein Netz: {n} Eingabe(n) sind sicher auf dem Gerät gespeichert und gehen automatisch raus.": "Nema mreže: {n} unos(a) sigurno je spremljeno na uređaju i automatski će se poslati.",
  "Kein Schutz vorhanden": "Nema zaštite",
  "Kein Trafofeld mit HH-Sicherungen erfasst – keine Schlagstiftauslösung.": "Nije uneseno transformatorsko polje s VN osiguračima (HH) – nema okidanja udarnom iglom.",
  "Kein Trafofeld mit HH-Sicherungen erfasst.": "Nije uneseno transformatorsko polje s VN osiguračima (HH).",
  "Kein oder schlechtes Netz.": "Nema mreže ili je slaba.",
  "Keine MS-Felder erfasst – Vorschläge zu Sicherungen und Messfeld sind erst möglich, wenn die Felder eingetragen sind.": "Nisu unesena SN polja – prijedlozi za osigurače i mjerno polje mogući su tek kad se polja upišu.",
  "Keine Module - bitte Stationskonfiguration pruefen.": "Nema modula - provjeri konfiguraciju stanice.",
  "Keine NS-Hauptverteilung in der Station.": "U stanici nema glavnog NN razvoda.",
  "Keine Wartungen offen": "Nema otvorenih održavanja",
  "Keine eigene MS-Anlage.": "Nema vlastitog SN postrojenja.",
  "Keine öl-gekuehlten Trafos in dieser Station.": "U ovoj stanici nema uljem hlađenih transformatora.",
  "Klemmen / Flachanschluss": "Stezaljke / plosnati priključak",
  "Klemmen mit Schutzhauben": "Stezaljke sa zaštitnim kapama",
  "Komprimierung fehlgeschlagen": "Komprimiranje nije uspjelo",
  "Konnte nicht gespeichert werden: {fehler}": "Nije se moglo spremiti: {fehler}",
  "Kunden": "Kupci",
  "Kundennummer": "Broj kupca",
  "L - Leistungsschalter": "L - prekidač snage",
  "Lade Bilder...": "Učitavam slike...",
  "Lade Erderanlage …": "Učitavam uzemljivač …",
  "Lade Protokoll …": "Učitavam zapisnik …",
  "Laut Anlage erforderlich": "Prema postrojenju potrebno",
  "Laut Anlage voraussichtlich nicht erforderlich": "Prema postrojenju vjerojatno nije potrebno",
  "Laut Stammdaten keine Erderanlage – jede Station braucht eine. Stammdaten prüfen.": "Prema matičnim podacima nema uzemljivača – svaka stanica ga treba. Provjeri matične podatke.",
  "Laut Stammdaten keine NS-Hauptverteilung in der Station.": "Prema matičnim podacima u stanici nema glavnog NN razvoda.",
  "Laut Stammdaten keine eigene MS-Anlage.": "Prema matičnim podacima nema vlastitog SN postrojenja.",
  "Laut Stammdaten keine Ölwanne – bei einem Öltrafo ist das ein Mangel, kein \"nicht benötigt\".": "Prema matičnim podacima nema uljne kade – kod uljnog transformatora to je nedostatak, a ne \"nije potrebno\".",
  "Lebenszyklus erreicht:": "Životni vijek dosegnut:",
  "Lebenszyklus nicht erreicht:": "Životni vijek nije dosegnut:",
  "Leistung [kVA]": "Snaga [kVA]",
  "Leiter-Art": "Vrsta vodiča",
  "Letzte Aktualisierung der Stammdaten: {datum}": "Zadnje ažuriranje matičnih podataka: {datum}",
  "Liste öffnen": "Otvori popis",
  "Luft (gekapselt)": "Zrak (oklopljeno)",
  "Luft, offene Bauweise": "Zrak, otvorena izvedba",
  "Luftisolierte Anlage mit Trafofeld: HH-Sicherungen nur mit der Sicherungszange wechseln.": "Zrakom izolirano postrojenje s transformatorskim poljem: VN osigurače (HH) mijenjaj samo kliještima za osigurače.",
  "Luftisolierte Anlage: Schutzplatten werden in offene Trennstrecken geschoben.": "Zrakom izolirano postrojenje: izolacijske ploče umeću se u otvorene rastavne razmake.",
  "Luftisolierte Anlage: Spannungsfreiheit wird mit dem MS-Spannungsprüfer festgestellt.": "Zrakom izolirano postrojenje: beznaponsko stanje utvrđuje se SN ispitivačem napona.",
  "Luftisolierte Anlage: geerdet wird mit der tragbaren Erdungs- und Kurzschließvorrichtung.": "Zrakom izolirano postrojenje: uzemljuje se prijenosnom napravom za uzemljenje i kratko spajanje (EuK).",
  "Luftisolierte Anlage: kein Isoliergas, keine Gasdruckanzeige.": "Zrakom izolirano postrojenje: nema izolacijskog plina, nema pokazivača tlaka plina.",
  "Luftisolierte Messfelder können Schutzplatten brauchen – je nach Bauart prüfen.": "Zrakom izolirana mjerna polja mogu trebati izolacijske ploče – provjeri ovisno o izvedbi.",
  "Länge L [m]": "Duljina L [m]",
  "Löschen": "Obriši",
  "M - Messfeld": "M - mjerno polje",
  "MANGEL ANGELEGT": "NEDOSTATAK KREIRAN",
  "MS-Anlage": "SN postrojenje",
  "MS-Felder ({n})": "SN polja ({n})",
  "MS-Verrechnungsmessung, aber kein Messfeld erfasst? Stammdaten prüfen.": "Obračunsko mjerenje na SN, ali nije uneseno mjerno polje? Provjeri matične podatke.",
  "MS-seitig voraussichtlich nicht nötig (Erdungsschalter in allen Feldern, Trafo gesteckt). NS-seitige Erdung trotzdem klären – bitte selbst bewerten.": "Na SN strani vjerojatno nije potrebno (zemljospojnik u svim poljima, transformator utaknut). Uzemljenje na NN strani ipak razjasni – ocijeni sam.",
  "Mangel.": "Nedostatak.",
  "Maße und Werte hier werden direkt in die Stammdaten der Station übernommen und überschreiben den vorherigen Stand. Wenn die Bewertung rot wird, legt die App automatisch einen Mangel im Prüfpunkt 05.1.5 an.": "Mjere i vrijednosti ovdje preuzimaju se izravno u matične podatke stanice i prepisuju prethodno stanje. Ako ocjena postane crvena, aplikacija automatski kreira nedostatak u točki provjere 05.1.5.",
  "Mehr": "Više",
  "Messfeld vorhanden: Messfelder haben meist keinen Erdungsschalter, sondern Kugelfestpunkte.": "Postoji mjerno polje: mjerna polja obično nemaju zemljospojnik, nego kuglaste točke za uzemljenje.",
  "Mitnahmeschaltung": "Spojno okidanje",
  "Mobil": "Mobitel",
  "Modelltyp": "Tip modela",
  "Modul": "Modul",
  "Modul {nr}": "Modul {nr}",
  "Moechtest du die Wartung TROTZDEM abschliessen?": "Želiš li UNATOČ tome završiti održavanje?",
  "Monteur": "Monter",
};
